module.exports = __webpack_public_path__ + "img/pricilla-pro.a20e88bd.jpg";